import Lookup from 'src/componentes/select2';

const TipoCargoLookup = (props) => (
  <Lookup labelKey="nome" valueKey="id" url="/TipoCargoLookup" {...props} />
);

export default TipoCargoLookup;
